<template>
  <ValidationObserver v-slot="{ valid, handleSubmit }" tag="div">
    <form
      :action="formAction"
      accept-charset="UTF-8"
      method="post"
      class="UsersForm"
      @submit="handleSubmit(onSubmit)"
    >
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <input v-if="formMethod" type="hidden" name="_method" :value="formMethod" />

      <component
        :is="getComponentNameByField(field)"
        v-for="field in fields"
        :key="field.name"
        :namespace="namespace"
        :field="field"
        :can-submit="valid"
        :is-submitting="isSubmitting"
        :is-failed-submitting="isFailedSubmitting"
        :is-visible-required="isVisibleRequired"
        :is-visible="conditions[field.condition]"
      />
    </form>
  </ValidationObserver>
</template>

<script>
import clone from 'lodash/clone'

import Vue from 'vue'
import { PhoneNumberUtil } from 'google-libphonenumber'
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'
import customErrorMessages from '../../data/errorMessages'

import store from './store.js'

import UsersForm from '../../mixins/UsersForm'

for (const rule in rules) {
  extend(rule, rules[rule])
}

// 電話番号カスタムバリデーションを追加
// 参考: https://qiita.com/hamakou108/items/47f56a8543ac432868c0
extend('phone', {
  message: '電話番号が正しく入力されているかご確認ください。',
  validate(value) {
    const util = PhoneNumberUtil.getInstance()
    try {
      const phoneNumber = util.parseAndKeepRawInput(value, 'JP')
      return util.isPossibleNumber(phoneNumber)
    } catch (err) {
      return false
    }
  },
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
localize('ja', Object.assign(clone(ja, true), customErrorMessages))

// eslint-disable-next-line no-unused-expressions
Promise

export default {
  name: 'CommonForm',
  mixins: [UsersForm],
  store,
}
</script>

<style lang="scss" scoped>
@import '../../css/vue_modules/users_form';
</style>
